<template>
  <div class="flex items-center justify-center">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00423D]"></div>
  </div>
</template>

<script setup>
// No additional logic needed
</script>

<style scoped>
/* No additional styles needed */
</style> 